import React from 'react'
import Dialog from '@mui/material/Dialog'
import { makeStyles } from '@mui/styles'
import DialogTitle from '@mui/material/DialogTitle'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import Slide from '@mui/material/Slide'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />
})

const useStyles = makeStyles((theme) => ({
  dialog: {
    margin: 0,
    padding: 0,
  },
  dialog__title: {
    width: '100%',
    margin: '0 auto',
    textAlign: 'center',
    fontSize: theme.fontSizes.giant,
    fontWeight: theme.fontWeights.medium,
    '& *': {
      textAlign: 'center',
    },
    '@media screen and (min-width: 1491px)': {
      paddingLeft: 360,
    },
    [theme.devices.mobile]: {
      fontSize: theme.fontSizes.xlarge,
    },
  },
  dialog__content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    margin: 0,
    padding: 0,
    minHeight: '100%',
    height: 'auto',
    '&:first-child': {
      paddingTop: 0,
    },
    backgroundColor: theme.superlightGrey,
  },
  dialog__main: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}))

const ModalFullscreen = (props) => {
  const classes = useStyles()
  const {
    title,
    actions,
    children,
    dataQsId,
    className,
    ...otherProps
  } = props

  const titleContent = title
    ? <DialogTitle className={classes.dialog__title} disableTypography>{title}</DialogTitle>
    : null
  const actionContent = actions && actions.length
    ? <DialogActions classes={{ root: classes.actions }}>{actions}</DialogActions>
    : null

  return (
    <Dialog
      fullScreen
      className={clsx(classes.dialog, className)}
      {...otherProps}
      slots={{ transition: Transition }}
      data-qs-id={dataQsId}>
      <DialogContent className={classes.dialog__content}>
        <div className={classes.dialog__main}>
          {titleContent}
          {children}
        </div>
      </DialogContent>
      {actionContent}
    </Dialog>
  )
}

ModalFullscreen.propTypes = {
  open: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  actions: PropTypes.array,
  children: PropTypes.object,
  onClose: PropTypes.func,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  dataQsId: PropTypes.string.isRequired,
}

export default ModalFullscreen
